import React from "react";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import ListItem from "../../components/ListItem/ListItem";
import { reportingData } from "../../data/crmReportingData";
import { ReportingWrapper } from "./ReportingStyle";

export const Reporting = () => {
  return (
    <ReportingWrapper>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="گزارشگیری"
        href1="/dashboard/crm"
      />
      <ListItem items={reportingData} />
    </ReportingWrapper>
  );
};
